/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentUpdateSocialVersionMutationRequest, ContentUpdateSocialVersionMutationResponse, ContentUpdateSocialVersionPathParams } from "../models/ContentUpdateSocialVersion";

export function getContentUpdateSocialVersionUrl(id: ContentUpdateSocialVersionPathParams["id"], platform: ContentUpdateSocialVersionPathParams["platform"]) {
  const res = { method: 'PUT', url: `/contents/${id}/social-version/${platform}/update` as const }  
  return res
}

/**
 * @summary Update social version before publishing
 * {@link /contents/:id/social-version/:platform/update}
 */
export async function contentUpdateSocialVersion(id: ContentUpdateSocialVersionPathParams["id"], platform: ContentUpdateSocialVersionPathParams["platform"], data?: ContentUpdateSocialVersionMutationRequest, config: Partial<RequestConfig<ContentUpdateSocialVersionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContentUpdateSocialVersionMutationResponse, ResponseErrorConfig<Error>, ContentUpdateSocialVersionMutationRequest>({ method : "PUT", url : getContentUpdateSocialVersionUrl(id, platform).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}